export const successIconSx = {
  color: 'green',
};
